import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/contact.css";

function ContactForm() {
  const { t, i18n } = useTranslation();

  // State for form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "", // Added phone field
    message: "",
  });

  // States for form status
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear errors and enable loading state
    setError(null);
    setIsLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BACKEND_URL}/send`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            phone: formData.phone, // Include phone in payload
            message: formData.message,
            language: i18n.language, // Pass selected language
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send message. Please try again later.");
      }

      setSubmitted(true);
    } catch (err) {
      console.error("Error:", err);
      setError(t("contactForm.error") || err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section
      id="contact"
      className="contact-section"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <h3>{t("contactForm.title")}</h3>

      {!submitted ? (
        <form onSubmit={handleSubmit} className="contact-form">
          {/* Name Input */}
          <input
            type="text"
            placeholder={t("contactForm.name")}
            required
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />

          {/* Email Input */}
          <input
            type="email"
            placeholder={t("contactForm.email")}
            required
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />

          {/* Phone Number Input */}
          <input
            type="tel"
            placeholder={t("contactForm.phone")}
            required
            value={formData.phone}
            onChange={(e) =>
              setFormData({ ...formData, phone: e.target.value })
            }
          />

          {/* Message Input */}
          <textarea
            placeholder={t("contactForm.message")}
            required
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
          ></textarea>

          {/* Submit Button */}
          <button type="submit" disabled={isLoading}>
            {isLoading ? t("contactForm.sending") : t("contactForm.send")}
          </button>
        </form>
      ) : (
        <p className="success-message">{t("contactForm.success")}</p>
      )}

      {/* Display Error Message */}
      {error && <p className="error-message">{error}</p>}
    </section>
  );
}

export default ContactForm;
